import styled from "styled-components";
import { getPropertyByMedia } from "../helpers";
export const BrComponent = styled.br `
	${({ display }) => getPropertyByMedia("display", display)}
`;
//# sourceMappingURL=styles.js.map